import { Dispatch } from "../../config/controller";
import { Model,StateProps } from "../../config/model";
import { Paciente } from "../paciente/paciente.model";


export interface PainelState extends StateProps<Paciente> {
    rows_calling:Paciente[]
    rows_call_done:Paciente[]
    chamando_paciente:{
        chamando:boolean
        paciente:Paciente
    }

}


export interface PainelActions extends Dispatch<Paciente> {
    readPacientesBySitChamouToday:()=>any
    setChamarPacientes:(pacientes:Paciente[]) => any
}

const model = new Model<Paciente,PainelState>("statusapp");


export const initialValuePainelState:PainelState = {
    ...model.getInititalValueState(),
    rows_call_done:[],
    rows_calling:[],
    chamando_paciente:{
        chamando:false,
        paciente:{} as Paciente
    }
}


